import Worker from './engine-warpper.worker.js'
import { script } from '@/../node_modules/dynamic-import/dist/import.js'
import { threads, simd, relaxedSimd } from 'wasm-feature-detect'

var callback, engineInstance, supportThreads, dataLoaded

function locateFile(url, engineDirURL) {
  // Redirect 'rapfi.*\.data' to 'rapfi.data'
  if (/^rapfi.*\.data$/.test(url)) url = 'rapfi.data'
  return engineDirURL + url
}

function getWasmMemoryArguments(isShared, maximum_memory_mb = 2048) {
  return {
    initial: 64 * ((1024 * 1024) / 65536), // 64MB
    maximum: maximum_memory_mb * ((1024 * 1024) / 65536),
    shared: isShared,
  }
}

function instantiateSharedWasmMemory() {
  let maximum_memory_mb = 2048
  // Find the maximum memory size that can be allocated
  while (maximum_memory_mb > 512) {
    try {
      const memory = new WebAssembly.Memory(getWasmMemoryArguments(true, maximum_memory_mb))
      memory.grow(1)
      return memory
    } catch (e) {
      maximum_memory_mb /= 2
    }
  }
  return new WebAssembly.Memory(getWasmMemoryArguments(true, maximum_memory_mb))
}

// Init engine and setup callback function for receiving engine output
async function init(callbackFn_) {
  callback = callbackFn_
  dataLoaded = false

  supportThreads = await threads()
  const supportSIMD = await simd()
  const supportRelaxedSIMD = supportThreads && (await relaxedSimd())

  const engineFlags =
    (supportThreads ? '-multi' : '-single') +
    (supportSIMD ? '-simd128' : '') +
    (supportRelaxedSIMD ? '-relaxed' : '')
  const engineURL = process.env.BASE_URL + `build/rapfi${engineFlags}.js`

  if (supportThreads) {
    await script.import(/* webpackIgnore: true */ engineURL)

    const engineDirURL = engineURL.substring(0, engineURL.lastIndexOf('/') + 1)

    engineInstance = await self['Rapfi']({
      locateFile: (url) => locateFile(url, engineDirURL),
      onReceiveStdout: (o) => onEngineStdout(o),
      onReceiveStderr: (o) => onEngineStderr(o),
      onExit: (c) => onEngineExit(c),
      setStatus: (s) => onEngineStatus(s),
      wasmMemory: instantiateSharedWasmMemory(),
    })
    dataLoaded = true
    callback({ ok: true })
  } else {
    engineInstance = new Worker()

    engineInstance.onmessage = (e) => {
      const { type, data } = e.data
      if (type === 'stdout') onEngineStdout(data)
      else if (type === 'stderr') onEngineStderr(data)
      else if (type === 'exit') onEngineExit(data)
      else if (type === 'status') onEngineStatus(data)
      else if (type === 'ready') {
        dataLoaded = true
        callback({ ok: true })
      }
      else console.error('received unknown message from worker: ', e.data)
    }

    engineInstance.onerror = (err) => {
      console.error('Worker error: ' + err.message + '\nretrying after 0.5s...')
      engineInstance.terminate()
      setTimeout(() => init(callback), 500)
    }

    engineInstance.postMessage({
      type: 'engineScriptURL',
      data: {
        engineURL: engineURL,
        memoryArgs: getWasmMemoryArguments(false),
      },
    })
  }
  
  return engineURL
}

// Stop current engine's thinking process
// Returns true if force stoped, otherwise returns false
function stopThinking() {
  if (supportThreads) {
    sendCommand('YXSTOP')
    return false
  } else {
    engineInstance.terminate()
    init(callback) // Use previous callback function
    return true
  }
}

// Send a command to engine
function sendCommand(cmd) {
  if (typeof cmd !== 'string' || cmd.length == 0) return

  if (supportThreads) engineInstance.sendCommand(cmd)
  else engineInstance.postMessage({ type: 'command', data: cmd })
}

// 解析活三威胁数据的辅助函数
function parseLivingThreeData(data, result) {
  // 格式: NONE2,FORBID0,L2,K1,J0,I1,H3,G2,F1,E0,D1,C1,B0,A0:070809,050607
  let colonIndex = data.indexOf(':')
  if (colonIndex === -1) return
  
  let countsStr = data.substring(0, colonIndex) // NONE2,FORBID0,L2,K1,J0,I1,H3,G2,F1,E0,D1,C1,B0,A0
  let positionsStr = data.substring(colonIndex + 1) // 070809,050607
  
  // 解析威胁数量
  if (countsStr) {
    let countParts = countsStr.split(',')
    for (let countPart of countParts) {
      if (countPart.startsWith('NONE')) {
        result.NONE = parseInt(countPart.substring(4)) || 0
      } else if (countPart.startsWith('FORBID')) {
        result.FORBID = parseInt(countPart.substring(6)) || 0
      } else if (countPart.startsWith('L')) {
        result.L = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('K')) {
        result.K = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('J')) {
        result.J = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('I')) {
        result.I = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('H')) {
        result.H = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('G')) {
        result.G = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('F')) {
        result.F = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('E')) {
        result.E = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('D')) {
        result.D = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('C')) {
        result.C = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('B')) {
        result.B = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('A')) {
        result.A = parseInt(countPart.substring(1)) || 0
      }
    }
  }
  
  // 解析威胁点坐标
  if (positionsStr) {
    let positions = positionsStr.split(',')
    for (let pos of positions) {
      if (pos.length >= 4) {
        let x = parseInt(pos.substring(0, 2))
        let y = parseInt(pos.substring(2, 4))
        if (x >= 0 && x < 15 && y >= 0 && y < 15) {
          result.positions.push([x, y])
        }
      }
    }
  }
}

// 解析威胁分析数据的辅助函数（只解析数量，不解析坐标）
function parseThreatData(data, result) {
  // 解析格式: A3,B2,C1,H1,FORBID2,NONE100
  if (data && data !== '') {
    let countParts = data.split(',')
    for (let countPart of countParts) {
      if (countPart.startsWith('NONE')) {
        result.NONE = parseInt(countPart.substring(4)) || 0
      } else if (countPart.startsWith('FORBID')) {
        result.FORBID = parseInt(countPart.substring(6)) || 0
      } else if (countPart.startsWith('L')) {
        result.L = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('K')) {
        result.K = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('J')) {
        result.J = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('I')) {
        result.I = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('H')) {
        result.H = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('G')) {
        result.G = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('F')) {
        result.F = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('E')) {
        result.E = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('D')) {
        result.D = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('C')) {
        result.C = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('B')) {
        result.B = parseInt(countPart.substring(1)) || 0
      } else if (countPart.startsWith('A')) {
        result.A = parseInt(countPart.substring(1)) || 0
      }
    }
  }
}

// process output from engine and call callback function
function onEngineStdout(output) {
  let i = output.indexOf(' ')

  if (i == -1) {
    if (output == 'OK') return
    else if (output == 'SWAP') callback({ swap: true })
    else {
      const coord = output.split(',')
      callback({ pos: [+coord[0], +coord[1]] })
    }
    return
  }

  let head = output.substring(0, i)
  let tail = output.substring(i + 1)

  if (head == 'MESSAGE') {
    if (tail.startsWith('REALTIME')) {
      let r = tail.split(' ')
      if (r.length < 3) {
        callback({
          realtime: {
            type: r[1],
          },
        })
      } else {
        let coord = r[2].split(',')
        callback({
          realtime: {
            type: r[1],
            pos: [+coord[0], +coord[1]],
          },
        })
      }
    } else {
      callback({ msg: tail })
    }
  } else if (head == 'INFO') {
    i = tail.indexOf(' ')
    head = tail.substring(0, i)
    tail = tail.substring(i + 1)

    if (head == 'PV') callback({ multipv: tail })
    else if (head == 'NUMPV') callback({ numpv: +tail })
    else if (head == 'DEPTH') callback({ depth: +tail })
    else if (head == 'SELDEPTH') callback({ seldepth: +tail })
    else if (head == 'NODES') callback({ nodes: +tail })
    else if (head == 'TOTALNODES') callback({ totalnodes: +tail })
    else if (head == 'TOTALTIME') callback({ totaltime: +tail })
    else if (head == 'SPEED') callback({ speed: +tail })
    else if (head == 'EVAL') callback({ eval: tail })
    else if (head == 'WINRATE') callback({ winrate: parseFloat(tail) })
    else if (head == 'BESTLINE')
      callback({ bestline: tail.match(/\d+,\d+/g).map((s) => s.split(',').map(Number)) })
  } else if (head == 'FORBID') {
    callback({
      forbid: (tail.match(/.{4}/g) || []).map((s) => {
        let coord = s.match(/([0-9][0-9])([0-9][0-9])/)
        let x = +coord[1]
        let y = +coord[2]
        return [x, y]
      }),
    })
  } else if (head == 'VCF') {
    let vcfSequence = []
    
    // 解析格式: VCF 070809100711. (坐标序列) 或 VCF . (无VCF)
    try {
      console.log('VCF raw data:', tail) // 调试信息
      
      // 去掉末尾的点号
      let cleanTail = tail.replace(/\.$/, '').trim()
      console.log('VCF cleaned tail:', cleanTail) // 调试信息
      
      if (cleanTail && cleanTail !== '') {
        // 解析坐标序列，每4个字符一个坐标（参考冲四解析逻辑）
        let matches = cleanTail.match(/.{4}/g) || []
        console.log('VCF matches:', matches) // 调试信息
        for (let i = 0; i < matches.length; i++) {
          let match = matches[i]
          // 直接解析坐标，无颜色前缀
          let x = +match.substring(0, 2)
          let y = +match.substring(2, 4)
          
          console.log('VCF step parsed:', { match, x, y, step: i + 1 }) // 调试信息
          
          // 临时取消坐标验证，直接显示所有坐标
          if (x >= 0 && x < 50 && y >= 0 && y < 50) {
            vcfSequence.push({
              pos: [x, y],
              step: i + 1  // 步骤序号从1开始
            })
            console.log('VCF coordinate added:', { x, y, step: i + 1 }) // 临时调试
          } else {
            console.warn('VCF coordinate out of range:', x, y, 'from match:', match)
          }
        }
      }
      
      console.log('VCF final sequence:', vcfSequence) // 调试信息
    } catch (error) {
      console.error('VCF parsing error:', error, 'tail:', tail)
    }
    
    callback({ vcf: vcfSequence })
  } else if (head == 'ATTACKFOUR') {
    let attackFourPoints = []
    // 解析格式: ATTACKFOUR B0708W0910.
    // B表示黑棋冲四点，W表示白棋冲四点
    try {
      console.log('AttackFour raw data:', tail) // 调试信息
      
      // 去掉末尾的点号
      let cleanTail = tail.replace(/\.$/, '').trim()
      
      // 如果只有点号或者为空，说明没有冲四点
      if (!cleanTail || cleanTail === '') {
        console.log('No AttackFour points found')
        callback({ attackFour: [] })
        return
      }
      
      let matches = cleanTail.match(/[BW][0-9]{4}/g) || []
      console.log('AttackFour matches:', matches) // 调试信息
      for (let match of matches) {
        let color = match[0] // 'B' 或 'W'
        let coordStr = match.substring(1) // 去掉颜色前缀
        let x = +coordStr.substring(0, 2)
        let y = +coordStr.substring(2, 4)
        
        // 验证坐标是否合理
        if (x >= 0 && x < 15 && y >= 0 && y < 15) {
          attackFourPoints.push({
            pos: [x, y],
            color: color === 'B' ? 'black' : 'white'
          })
        } else {
          console.warn('AttackFour coordinate out of range:', x, y, 'from match:', match)
          // 临时添加调试信息
          console.log('AttackFour coordinate details:', { x, y, match, coordStr: match.substring(1) })
        }
      }
      console.log('AttackFour parsed points:', attackFourPoints) // 调试信息
    } catch (error) {
      console.error('AttackFour parsing error:', error, 'tail:', tail)
    }
    callback({ attackFour: attackFourPoints })
  } else if (head == 'LIVINGTHREE') {
    let livingThree = []
    
    // 解析格式: LIVINGTHREE B0708W0910.
    try {
      console.log('LivingThree raw data:', tail) // 调试信息
      
      // 去掉末尾的点号
      let cleanTail = tail.replace(/\.$/, '').trim()
      
      if (cleanTail && cleanTail !== '') {
        let matches = cleanTail.match(/[BW][0-9]{4}/g) || []
        console.log('LivingThree matches:', matches) // 调试信息
        for (let match of matches) {
          let color = match[0] // 'B' 或 'W'
          let coordStr = match.substring(1) // 去掉颜色前缀
          let x = +coordStr.substring(0, 2)
          let y = +coordStr.substring(2, 4)
          
          // 验证坐标是否合理
          if (x >= 0 && x < 15 && y >= 0 && y < 15) {
            livingThree.push({
              pos: [x, y],
              color: color === 'B' ? 'black' : 'white'
            })
          } else {
            console.warn('LivingThree coordinate out of range:', x, y, 'from match:', match)
          }
        }
      }
      
      console.log('LivingThree parsed:', livingThree) // 调试信息
    } catch (error) {
      console.error('LivingThree parsing error:', error, 'tail:', tail)
    }
    
    callback({ livingThree: livingThree })
  } else if (head == 'THREATANALYSIS') {
    let threatAnalysis = {
      black: { NONE: 0, FORBID: 0, L: 0, K: 0, J: 0, I: 0, H: 0, G: 0, F: 0, E: 0, D: 0, C: 0, B: 0, A: 0 },
      white: { NONE: 0, FORBID: 0, L: 0, K: 0, J: 0, I: 0, H: 0, G: 0, F: 0, E: 0, D: 0, C: 0, B: 0, A: 0 }
    }
    
    // 解析格式: THREATANALYSIS B:A3,B2,C1,H1,FORBID2,NONE100 W:A2,B1,C0,H0,FORBID1,NONE95.
    try {
      console.log('ThreatAnalysis raw data:', tail) // 调试信息
      
      // 去掉末尾的点号
      let cleanTail = tail.replace(/\.$/, '').trim()
      
      if (cleanTail && cleanTail !== '') {
        // 分割黑白双方数据
        let parts = cleanTail.split(' ')
        
        for (let part of parts) {
          if (part.startsWith('B:')) {
            // 解析黑棋数据
            parseThreatData(part.substring(2), threatAnalysis.black)
          } else if (part.startsWith('W:')) {
            // 解析白棋数据
            parseThreatData(part.substring(2), threatAnalysis.white)
          }
        }
      }
      
      console.log('ThreatAnalysis parsed:', threatAnalysis) // 调试信息
    } catch (error) {
      console.error('ThreatAnalysis parsing error:', error, 'tail:', tail)
    }
    
    callback({ threatAnalysis: threatAnalysis })
  } else if (head == 'ERROR') {
    callback({ error: tail })
  } else if (head.indexOf(',') != -1) {
    const coord1 = head.split(',')
    const coord2 = tail.split(',')
    callback({
      pos: [+coord1[0], +coord1[1]],
      pos2: [+coord2[0], +coord2[1]],
    })
  } else {
    callback({ unknown: tail })
  }
}

function onEngineStderr(output) {
  console.error('[Engine Error] ' + output)
}

function onEngineExit(code) {
  console.log('[Engine Exit] ' + code)
}

function onEngineStatus(status) {
  if (dataLoaded) return

  if (status === 'Running...' || status === '') {
    dataLoaded = true
    callback({
      loading: {
        progress: 1.0,
      },
    })
  }

  const match = status.match(/\((\d+)\/(\d+)\)/)
  if (match) {
    const loadedBytes = parseInt(match[1], 10)
    const totalBytes = parseInt(match[2], 10)
    if (loadedBytes == totalBytes) dataLoaded = true
    callback({
      loading: {
        progress: loadedBytes / totalBytes,
        loadedBytes: loadedBytes,
        totalBytes: totalBytes,
      },
    })
  }
}

export { init, sendCommand, stopThinking }
